import React, { useState } from "react";
import classes from "./AddPatientModal.module.css";
import {
    FaTimes,
    FaUserPlus,
    FaUser,
    FaPhone,
    FaHeartbeat,
    FaUsers,
    FaShieldAlt,
    FaFileAlt,
    FaUndo,
    FaArrowRight,
} from "react-icons/fa";

function AddPatientModal({ show, onClose }) {
  

    const [form, setForm] = useState({
        firstName: "",
        middleName: "",
        lastName: "",
        uhid: "",
        dob: "",
        age: "",
        gender: "",
        bloodGroup: "",
        maritalStatus: "",
        nationality: "",
        religion: "",
        occupation: "",
        idType: "",
        idNumber: "",
        registrationDate: "",
        referredBy: "",
        address1: "",
        address2: "",
        country: "",
        state: "",
        city: "",
        postalCode: "",
        department: "",
        doctor: "",
        consultationType: "",
    });

    const handleChange = (e) => {
        setForm({
            ...form,
            [e.target.name]: e.target.value,
        });
    };

    const handleReset = () => {
        setForm({
            firstName: "",
            middleName: "",
            lastName: "",
            uhid: "",
            dob: "",
            age: "",
            gender: "",
            bloodGroup: "",
            maritalStatus: "",
            nationality: "",
            religion: "",
            occupation: "",
            idType: "",
            idNumber: "",
            registrationDate: "",
            referredBy: "",
            address1: "",
            address2: "",
            country: "",
            state: "",
            city: "",
            postalCode: "",
            department: "",
            doctor: "",
            consultationType: "",
        });
    };
  if (!show) return null;
    return (
        <div className={classes.overlay}>
            <div className={classes.modal}>

                {/* HEADER */}

                <div className={classes.header}>

                    <div className={classes.headerLeft}>

                        <div className={classes.headerIcon}>
                            <FaUserPlus />
                        </div>

                        <div>
                            <h2>Add New Patient</h2>
                            <p>Fill in the details below to register a new patient</p>
                        </div>

                    </div>

                    <button
                        className={classes.closeBtn}
                        onClick={onClose}
                    >
                        <FaTimes />
                    </button>

                </div>

                {/* TABS */}

                <div className={classes.tabs}>

                    <button className={`${classes.tab} ${classes.active}`}>
                        <FaUser />
                        Personal Information
                    </button>

                    <button className={classes.tab}>
                        <FaPhone />
                        Contact Information
                    </button>

                    <button className={classes.tab}>
                        <FaHeartbeat />
                        Medical Information
                    </button>

                    <button className={classes.tab}>
                        <FaUsers />
                        Emergency Contact
                    </button>

                    <button className={classes.tab}>
                        <FaShieldAlt />
                        Insurance Information
                    </button>

                    <button className={classes.tab}>
                        <FaFileAlt />
                        Documents
                    </button>

                </div>

                <div className={classes.body}>

                    {/* PERSONAL DETAILS */}

                    <h3>Personal Details</h3>

                    <div className={classes.grid4}>

                        <div>
                            <label>First Name *</label>
                            <input
                                name="firstName"
                                value={form.firstName}
                                onChange={handleChange}
                            />
                        </div>

                        <div>
                            <label>Middle Name</label>
                            <input
                                name="middleName"
                                value={form.middleName}
                                onChange={handleChange}
                            />
                        </div>

                        <div>
                            <label>Last Name *</label>
                            <input
                                name="lastName"
                                value={form.lastName}
                                onChange={handleChange}
                            />
                        </div>

                        <div>
                            <label>UHID / MRN *</label>
                            <input
                                placeholder="Auto generated"
                                readOnly
                            />
                        </div>

                        <div>
                            <label>Date of Birth *</label>
                            <input
                                type="date"
                                name="dob"
                                value={form.dob}
                                onChange={handleChange}
                            />
                        </div>

                        <div>
                            <label>Age *</label>
                            <input
                                name="age"
                                value={form.age}
                                onChange={handleChange}
                            />
                        </div>

                        <div>
                            <label>Gender *</label>

                            <select
                                name="gender"
                                value={form.gender}
                                onChange={handleChange}
                            >
                                <option>Select gender</option>
                                <option>Male</option>
                                <option>Female</option>
                            </select>

                        </div>

                        <div>

                            <label>Blood Group</label>

                            <select
                                name="bloodGroup"
                                value={form.bloodGroup}
                                onChange={handleChange}
                            >
                                <option>Select blood group</option>
                                <option>A+</option>
                                <option>A-</option>
                                <option>B+</option>
                                <option>B-</option>
                                <option>AB+</option>
                                <option>AB-</option>
                                <option>O+</option>
                                <option>O-</option>
                            </select>

                        </div>

                        <div>
                            <label>Marital Status</label>

                            <select
                                name="maritalStatus"
                                value={form.maritalStatus}
                                onChange={handleChange}
                            >
                                <option>Select marital status</option>
                                <option>Single</option>
                                <option>Married</option>
                            </select>

                        </div>

                        <div>
                            <label>Nationality</label>
                            <input
                                name="nationality"
                                value={form.nationality}
                                onChange={handleChange}
                            />
                        </div>

                        <div>
                            <label>Religion</label>
                            <input
                                name="religion"
                                value={form.religion}
                                onChange={handleChange}
                            />
                        </div>

                        <div>
                            <label>Occupation</label>
                            <input
                                name="occupation"
                                value={form.occupation}
                                onChange={handleChange}
                            />
                        </div>

                        <div>
                            <label>Identification Type</label>

                            <select
                                name="idType"
                                value={form.idType}
                                onChange={handleChange}
                            >
                                <option>Select ID Type</option>
                                <option>NIN</option>
                                <option>Passport</option>
                            </select>

                        </div>

                        <div>
                            <label>Identification Number</label>
                            <input
                                name="idNumber"
                                value={form.idNumber}
                                onChange={handleChange}
                            />
                        </div>

                        <div>
                            <label>Date of Registration *</label>

                            <input
                                type="date"
                                name="registrationDate"
                                value={form.registrationDate}
                                onChange={handleChange}
                            />

                        </div>

                        <div>
                            <label>Referred By</label>

                            <input
                                name="referredBy"
                                value={form.referredBy}
                                onChange={handleChange}
                            />

                        </div>

                    </div>

                    {/* ADDRESS */}

                    <h3>Address Information</h3>

                    <div className={classes.grid4}>

                        <div className={classes.full}>
                            <label>Address Line 1 *</label>
                            <input
                                name="address1"
                                value={form.address1}
                                onChange={handleChange}
                            />
                        </div>

                        <div className={classes.full}>
                            <label>Address Line 2</label>
                            <input
                                name="address2"
                                value={form.address2}
                                onChange={handleChange}
                            />
                        </div>

                        <div>
                            <label>Country</label>
                            <input
                                name="country"
                                value={form.country}
                                onChange={handleChange}
                            />
                        </div>

                        <div>
                            <label>State</label>
                            <input
                                name="state"
                                value={form.state}
                                onChange={handleChange}
                            />
                        </div>

                        <div>
                            <label>City</label>
                            <input
                                name="city"
                                value={form.city}
                                onChange={handleChange}
                            />
                        </div>

                        <div>
                            <label>Postal Code</label>
                            <input
                                name="postalCode"
                                value={form.postalCode}
                                onChange={handleChange}
                            />
                        </div>

                    </div>

                    {/* PRIMARY PHYSICIAN */}

                    <h3>Primary Physician</h3>

                    <div className={classes.grid3}>

                        <div>
                            <label>Department</label>
                            <input
                                name="department"
                                value={form.department}
                                onChange={handleChange}
                            />
                        </div>

                        <div>
                            <label>Doctor</label>
                            <input
                                name="doctor"
                                value={form.doctor}
                                onChange={handleChange}
                            />
                        </div>

                        <div>
                            <label>Consultation Type</label>
                            <input
                                name="consultationType"
                                value={form.consultationType}
                                onChange={handleChange}
                            />
                        </div>

                    </div>

                </div>

                {/* FOOTER */}

                <div className={classes.footer}>

                    <div className={classes.note}>
                        After saving, you can add more details, documents and medical history from the patient profile.
                    </div>

                    <div className={classes.footerButtons}>

                        <button
                            className={classes.reset}
                            onClick={handleReset}
                            type="button"
                        >
                            <FaUndo />
                            Reset
                        </button>

                        <button className={classes.next}>
                            Next
                            <FaArrowRight />
                        </button>

                    </div>

                </div>

            </div>
        </div>
    );
}

export default AddPatientModal;